/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";

function PGE_42_MainPageInformation() {
  return (
    <MKBox component="section" py={12}>
      <Container>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} lg={12} sx={{ ml: "auto", mt: { xs: 3, lg: 0 } }}>
            <DefaultInfoCard
              //icon="info"
              title="Provincial General Election 2024"
              description={
                <>
                  <h4>The 42nd Provincial General Election was held in Nova Scotia on Tuesday, November 26, 2024.</h4>
                  <br />
                  <h3>Recount Results – Electoral District 55 Yarmouth</h3>
                  <br />
                  <p>A judicial recount of all ballots cast in electoral district 55 Yarmouth for the 42nd provincial general election, was held on Monday, December 9, 2024. The application for this judicial recount was made by Liberal candidate Zach Churchill.</p>
                  <br /><p>The results of the recount are as follows:</p>
                  <br /><p>Zach Churchill, Nova Scotia Liberal Party (Liberal) – 3,647</p>
                  <br /><p>Nick Hilton,  Progressive Conservative Association of Nova Scotia (PC) – 3,663</p>
                  <br /><p>Adam Randall, Green Party of Nova Scotia (Green Party) -  62</p>
                  <br /><p>Gillian Rowley, Nova Scotia New Democratic Party (NSNDP) - 208</p>
                  <br /><p>Following the recount, Nick Hilton PC was confirmed as the winning candidate for Nova Scotia.</p>
                  <br /><p>The previous results following the provincial general election on Tuesday, November 26, 2024 in the electoral district of Yarmouth were as follows:</p>
                  <br /><p>Zach Churchill, Liberal – 3,649</p>
                  <br /><p>Nick Hilton, PC – 3,663</p>
                  <br /><p>Adam Randall, Green Party - 62</p>
                  <br /><p>Gillian Rowley, NSNDP - 211</p>

                  <br /><h3>Recount Results – Electoral District 1 Annapolis</h3>

                  <br /><p>A judicial recount of all ballots cast in electoral district 1 Annapolis for the 42nd provincial general election, was held on Tuesday, December 10, 2024. The application for this recount was made by Elections Nova Scotia under clause 148 (3)(b)(c)(d) of the Elections Act, because there are only 7 votes separating the top two candidates. </p>

                  <br /><p>The results of the recount are as follows:</p>

                  <br /><p>Sara Adams, Green Party of Nova Scotia (Green Party) - 138</p>
                  <br /><p>David Bowlby, Progressive Conservative Association of Nova Scotia (PC) – 3,289</p>
                  <br /><p>Cheryl Burbridge, Nova Scotia New Democratic Party (NSNDP) - 689</p>
                  <br /><p>Carman Kerr, Nova Scotia Liberal Party (Liberal) – 3,281</p>

                  <br /><p>Following the recount, David Bowlby PC was confirmed as the winning candidate for Nova Scotia.</p>

                  <br /><p>The previous results following the provincial general election on Tuesday, November 26, 2024 in the electoral district of Annapolis were as follows:</p>

                  <br /><p>Sara Adams, Green Party - 139</p>
                  <br /><p>David Bowlby, PC – 3,291</p>
                  <br /><p>Cheryl Burbridge, NSNDP - 689</p>
                  <br /><p>Carman Kerr, Liberal – 3,284</p>


                  <br /><p>The deadline to apply for a judicial recount for the provincial general election was Monday, December 2, 2024.</p>

                  <br />
                  <h3>Provincial General Election Official Results</h3>
                  <br /><p>Official addition results for the 55 electoral districts are now available on the Elections Nova Scotia website (electionsnovascotia.ca).</p>
                  <br />
                  <p>Follow this link to view the <u><a href="https://results.electionsns.ca/">official results</a></u> for the 42nd provincial general election.</p>
                  <br />
                  <p>The following indicates the number of electoral districts for each registered political party and independent candidates:</p>

                  <br /><p>Green Party: 0 electoral districts</p>
                  <br /><p>Liberal: 2 electoral districts</p>
                  <br /><p>NDP: 9 electoral districts</p>
                  <br /><p>NS United: 0 electoral districts</p>
                  <br /><p>PC Party: 43 electoral districts</p>
                  <br /><p>Independent candidates: 1 electoral districts</p>

                  <br /><p>The total number of ballots cast was 356,308.</p>

                  <br /><p>As of Sunday, November 24, 2024, there were 788,427 registered voters in Nova Scotia.</p>


                  <br /><p>A candidate is officially declared elected when the writ of election has been completed and returned by the returning officer to the Chief Electoral Officer per section 159 of the <u><i><a href="http://nslegislature.ca/legc/statutes/elections.pdf"><em>Elections Act</em></a></i></u>.</p>
                  <br />
                  <p>Poll-by-poll results and further analysis on voter turnout for the provincial general election will be published in Elections Nova Scotia’s post-election report in the coming months.</p>
                  <br />
                  <h3>List of Elected</h3>
                  <br />
                  <table border="1" cellPadding="1" cellSpacing="1">
                    <thead>
                      <tr>
                        <th>Electoral District</th>
                        <th>Elected Candidate</th>
                        <th>Registered Political Party or Independent</th>

                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="style1" style={{ height: '25px' }}>01 - Annapolis</td>
                        <td className="style1">David Bowlby</td>
                        <td className="style1">PC</td>
                      </tr>
                      <tr>
                        <td className="style1" style={{ height: '30px' }}>02 - Antigonish</td>
                        <td className="style1">Michelle Thompson</td>
                        <td className="style1">PC</td>
                      </tr>
                      <tr>
                        <td className="style1">03 - Argyle</td>
                        <td className="style1">Colton LeBlanc</td>
                        <td className="style1">PC</td>

                      </tr>
                      <tr>
                        <td className="style1">04 - Bedford Basin</td>
                        <td className="style1">Tim Outhit</td>
                        <td className="style1">PC</td>
                      </tr>
                      <tr>
                        <td className="style1">05 - Bedford South</td>
                        <td className="style1">Damian Stoilov</td>
                        <td className="style1">PC</td>

                      </tr>
                      <tr>
                        <td className="style1">06 - Cape Breton Centre-Whitney Pier</td>
                        <td className="style1">Kendra Coombes</td>
                        <td className="style1">NSNDP</td>
                      </tr>
                      <tr>
                        <td className="style1">07 - Cape Breton East</td>
                        <td className="style1">Brian Comer</td>
                        <td className="style1">PC</td>
                      </tr>
                      <tr>
                        <td className="style1">08 - Chester-St. Margaret&#39;s </td>
                        <td className="style1">Danielle Barkhouse</td>
                        <td className="style1">PC</td>
                      </tr>
                      <tr>
                        <td className="style1">09 - Clare </td>
                        <td className="style1">Ryan Robicheau</td>
                        <td className="style1">PC</td>
                      </tr>
                      <tr>
                        <td className="style1">10 - Clayton Park West </td>
                        <td className="style1">Adegoke Fadare</td>
                        <td className="style1">PC</td>
                      </tr>
                      <tr>
                        <td className="style1">11 - Colchester-Musquodoboit Valley </td>
                        <td className="style1">Scott Armstrong</td>
                        <td className="style1">PC</td>

                      </tr>
                      <tr>
                        <td className="style1">12 - Colchester North </td>
                        <td className="style1">Tom Taggart</td>
                        <td className="style1">PC</td>
                      </tr>
                      <tr>
                        <td className="style1">13 - Cole Harbour</td>
                        <td className="style1">Leah Martin</td>
                        <td className="style1">PC</td>
                      </tr>
                      <tr>
                        <td className="style1">14 - Cole Harbour-Dartmouth </td>
                        <td className="style1">Brad McGowan</td>
                        <td className="style1">PC</td>
                      </tr>
                      <tr>
                        <td className="style1">15 - Cumberland North</td>
                        <td className="style1">Elizabeth Smith-McCrossin</td>
                        <td className="style1">Independent</td>
                      </tr>
                      <tr>
                        <td className="style1">16 - Cumberland South </td>
                        <td className="style1">Tory Rushton</td>
                        <td className="style1">PC</td>

                      </tr>
                      <tr>
                        <td className="style1">17 - Dartmouth East</td>
                        <td className="style1">Timothy Halman</td>
                        <td className="style1">PC</td>
                      </tr>
                      <tr>
                        <td className="style1">18 - Dartmouth North</td>
                        <td className="style1">Susan Leblanc</td>
                        <td className="style1">NSNDP</td>

                      </tr>
                      <tr>
                        <td className="style1">19 - Dartmouth South</td>
                        <td className="style1">Claudia Chender</td>
                        <td className="style1">NSNDP</td>
                      </tr>
                      <tr>
                        <td className="style1">20 - Digby-Annapolis </td>
                        <td className="style1">Jill Balser</td>
                        <td className="style1">PC</td>

                      </tr>
                      <tr>
                        <td className="style1">21 - Eastern Passage </td>
                        <td className="style1"> Barbara Adams </td>
                        <td className="style1">PC</td>
                      </tr>
                      <tr>
                        <td className="style1">22 - Eastern Shore </td>
                        <td className="style1">Kent Smith</td>
                        <td className="style1">PC</td>
                      </tr>
                      <tr>
                        <td className="style1">23 - Fairview-Clayton Park </td>
                        <td className="style1">Lina Hamid</td>
                        <td className="style1">NSNDP</td>
                      </tr>
                      <tr>
                        <td className="style1">24 - Glace Bay-Dominion </td>
                        <td className="style1">John White</td>
                        <td className="style1">PC</td>
                      </tr>
                      <tr>
                        <td className="style1" style={{ height: '30px' }}>25 - Guysborourgh-Tracadie</td>
                        <td className="style1">Greg Morrow</td>
                        <td className="style1"> PC</td>
                      </tr>
                      <tr>
                        <td className="style1">26 - Halifax Armdale </td>
                        <td className="style1">Rod Wilson</td>
                        <td className="style1">NSNDP</td>
                      </tr>
                      <tr>
                        <td className="style1">27 - Halifax Atlantic </td>
                        <td className="style1">Brendan Maguire</td>
                        <td className="style1">PC</td>
                      </tr>
                      <tr>
                        <td className="style1" style={{ height: '30px' }}>28 - Halifax Chebucto </td>
                        <td className="style1">Krista Gallagher</td>
                        <td className="style1">NSNDP</td>

                      </tr>
                      <tr>
                        <td className="style1">29 - Halifax Citadel-Sable Island </td>
                        <td className="style1">Lisa Lachance</td>
                        <td className="style1">NSNDP</td>
                      </tr>
                      <tr>
                        <td className="style1">30 - Halifax Needham </td>
                        <td className="style1">Suzy Hansen</td>
                        <td className="style1"> NSNDP</td>
                      </tr>
                      <tr>

                        <td className="style1">31 - Hammonds Plains-Lucasville </td>
                        <td className="style1"> Rick Burns</td>
                        <td className="style1"> PC</td>
                      </tr>
                      <tr>
                        <td className="style1">32 - Hants East </td>
                        <td className="style1">John A. MacDonald</td>
                        <td className="style1">PC</td>
                      </tr>
                      <tr>
                        <td className="style1">33 - Hants West </td>
                        <td className="style1">Melissa Sheehy-Richard</td>
                        <td className="style1">PC</td>
                      </tr>
                      <tr>
                        <td className="style1">34 - Inverness </td>
                        <td className="style1">Kyle MacQuarrie</td>
                        <td className="style1">PC</td>
                      </tr>
                      <tr>
                        <td className="style1">35 - Kings North </td>
                        <td className="style1">John A. Lohr</td>
                        <td className="style1">PC</td>
                      </tr>
                      <tr>
                        <td className="style1" style={{ height: '30px' }}>36 - Kings South </td>
                        <td className="style1">Julie Vanexan</td>
                        <td className="style1">PC</td>
                      </tr>
                      <tr>
                        <td className="style1">37 - Kings West </td>
                        <td className="style1">Chris Palmer</td>
                        <td className="style1"> PC</td>
                      </tr>
                      <tr>
                        <td className="style1">38 - Lunenburg </td>
                        <td className="style1">Susan Corkum-Greek</td>
                        <td className="style1">PC</td>
                      </tr>
                      <tr>
                        <td className="style1">39 - Lunenburg West </td>
                        <td className="style1">Becky Druhan</td>
                        <td className="style1">PC</td>
                      </tr>
                      <tr>
                        <td className="style1">40 - Northside Westmount </td>
                        <td className="style1">Fred Tilley</td>
                        <td className="style1">PC</td>
                      </tr>
                      <tr>
                        <td className="style1">41 - Pictou Centre </td>
                        <td className="style1">Danny MacGillivray</td>
                        <td className="style1"> PC</td>
                      </tr>
                      <tr>
                        <td className="style1">42 - Pictou East </td>
                        <td className="style1"> Tim Houston </td>
                        <td className="style1">PC</td>
                      </tr>
                      <tr>
                        <td className="style1">43 - Pictou West </td>
                        <td className="style1">Marco MacLeod</td>
                        <td className="style1">PC</td>
                      </tr>
                      <tr>
                        <td className="style1">44 - Preston </td>
                        <td className="style1">Twila Grosse</td>
                        <td className="style1">PC</td>
                      </tr>
                      <tr>
                        <td className="style1">45 - Queens </td>
                        <td className="style1">Kim Masland</td>
                        <td className="style1">PC</td>
                      </tr>
                      <tr>
                        <td className="style1">46 - Richmond </td>
                        <td className="style1"> Trevor Boudreau</td>
                        <td className="style1">PC</td>

                      </tr>

                      <tr>
                        <td className="style1">47 - Sackville-Cobequid </td>
                        <td className="style1">Paul Wozney</td>
                        <td className="style1">NSNDP</td>
                      </tr>
                      <tr>
                        <td className="style1">48 - Sackville-Uniacke </td>
                        <td className="style1">Brad Johns</td>
                        <td className="style1"> PC</td>
                      </tr>
                      <tr>
                        <td className="style1">49 - Shelburne </td>
                        <td className="style1">Nolan Young</td>
                        <td className="style1"> PC</td>
                      </tr>
                      <tr>
                        <td className="style1">50 - Sydney-Membertou </td>
                        <td className="style1">Derek Mombourquette</td>
                        <td className="style1">Liberal</td>

                      </tr>
                      <tr>
                        <td className="style1">51 - Timberlea-Prospect </td>
                        <td className="style1"> Iain Rankin</td>
                        <td className="style1"> Liberal</td>
                      </tr>
                      <tr>
                        <td className="style1">52 - Truro-Bible Hill-Millbrook-Salmon River </td>
                        <td className="style1"> Dave Ritcey </td>
                        <td className="style1">PC</td>
                      </tr>
                      <tr>
                        <td className="style1">53 - Victoria-The Lakes </td>
                        <td className="style1"> Dianne L. Timmins</td>
                        <td className="style1">PC</td>
                      </tr>
                      <tr>
                        <td className="style1">54 - Waverley-Fall River-Beaver Bank </td>
                        <td className="style1">Brian Wong</td>
                        <td className="style1">PC</td>

                      </tr>
                      <tr>
                        <td className="style1">55 - Yarmouth </td>
                        <td className="style1">Nick Hilton</td>
                        <td className="style1">PC</td>
                      </tr>

                    </tbody>
                  </table>
                  <br />
                  <h3>Financial Reporting Deadlines for the 42nd Provincial General Election</h3>
                  <br />
                  <p>Elections Nova Scotia reminds all nominated candidates, registered political parties, and third party advertisers from the 42nd provincial general election held on Tuesday, November 26, 2024, that financial reports are due in the weeks and months ahead. All reports must be sent to the Chief Electoral Officer.</p>
                  <br />
                  <p>Candidate tax receipts are due 30 days after election day, <strong>December 30, 2024</strong>.</p>
                  <br />
                  <p>Candidate financial reports, including audit reports, are due (80 days after writ) on <strong>February 28, 2025</strong>. It is also important to remember that there are <strong>fines of $50 per day</strong> for late candidate reports.</p>
                  <br />
                  <p>Registered party financial reports are due (120 days after Writ) on <strong>April 9, 2025</strong>.</p>
                  <br />
                  <p>Third party election advertising reports are due on <strong>March 26, 2025</strong>.</p>

                  <br />
                  <br />
                  ENS is an independent non-partisan agency that reports to the members of the House of Assembly through the Speaker. Its mandate is to deliver provincial elections impartially and professionally.
 
                  {/* <br />
                  <h3>Provincial General Election Media Releases</h3>
                  <br />Elections Nova Scotia issues media releases throughout the provincial general election to update voters. Click here to view the list of <u><i><a href="https://electionsnovascotia.ca/news"> media releases for the provincial general election</a></i></u>. */}
                </>
              }
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default PGE_42_MainPageInformation;
